module.exports = __webpack_public_path__ + "img/FB.a0dd2fce.svg";